import api from './api';

/**
 * 求职申请记录接口
 */
export interface JobApplication {
  id?: number;
  userId?: number;
  companyName: string;
  city?: string;
  websiteUrl?: string;
  positionName: string;
  applicationStatus: string;
  interviewTime?: string;
  salary?: string;
  applicationDate?: string;
  applicationTime?: string;
  remarks?: string;
  createTime?: string;
  updateTime?: string;
}

/**
 * 查询参数接口
 */
export interface QueryParams {
  page?: number;
  size?: number;
  keyword?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}

/**
 * 分页结果接口
 */
export interface PageResult<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

/**
 * 求职申请服务
 */
const jobApplicationService = {
  /**
   * 创建求职申请记录
   * @param data 求职申请数据
   * @returns 创建的求职申请记录
   */
  async create(data: JobApplication): Promise<JobApplication> {
    const response = await api.post('/api/job-applications', data);
    return response.data;
  },

  /**
   * 更新求职申请记录
   * @param id 记录ID
   * @param data 更新数据
   * @returns 更新后的记录
   */
  async update(id: number, data: JobApplication): Promise<JobApplication> {
    const response = await api.put(`/api/job-applications/${id}`, data);
    return response.data;
  },

  /**
   * 删除求职申请记录
   * @param id 记录ID
   * @returns 操作结果
   */
  async delete(id: number): Promise<any> {
    const response = await api.delete(`/api/job-applications/${id}`);
    return response.data;
  },

  /**
   * 获取求职申请记录列表
   * @param params 查询参数
   * @returns 分页结果
   */
  async getList(params: QueryParams = {}): Promise<PageResult<JobApplication>> {
    // 确保page参数至少为1
    const queryParams = { ...params };
    if (queryParams.page !== undefined) {
      queryParams.page = Math.max(1, queryParams.page);
    } else {
      queryParams.page = 1;
    }
    
    const response = await api.get('/api/job-applications', { params: queryParams });
    return response.data;
  },

  /**
   * 获取求职申请记录详情
   * @param id 记录ID
   * @returns 记录详情
   */
  async getById(id: number): Promise<JobApplication> {
    const response = await api.get(`/api/job-applications/${id}`);
    return response.data;
  },
  
  /**
   * 获取求职申请统计数据
   * @returns 各状态的统计数据
   */
  async getStats(): Promise<Record<string, number>> {
    const response = await api.get('/api/job-applications/stats');
    return response.data;
  }
};

export default jobApplicationService; 